import React, { FC, memo } from 'react';
import { WarehouseForBooking } from 'entities/Warehouse';
import { UnifiedWarehouseMap } from 'widgets/UnifiedWarehouseMap';
import WarehouseDefaultImage from 'shared/assets/images/WarehouseDefaultImage.png';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

interface WarehouseImageAndMapProps {
  warehouseInfo: WarehouseForBooking;
}

export const WarehouseImageAndMap: FC<WarehouseImageAndMapProps> = memo((props) => {
  const { warehouseInfo } = props;
  const { isDesktop } = useScreenBreakpoints();

  const warehouseImage = warehouseInfo?.imageUrl || WarehouseDefaultImage;

  // Mobile: show only image
  if (!isDesktop) {
    return (
      <div className="bg-white rounded-lg overflow-hidden w-full h-[200px]">
        <img src={warehouseImage} alt={warehouseInfo?.name || 'Warehouse'} className="w-full h-full object-cover" />
      </div>
    );
  }

  // Desktop: show image and map side by side
  return (
    <div className="bg-white rounded-lg overflow-hidden w-full h-[320px]">
      <div className="grid grid-cols-2 gap-0 h-full">
        <div className="relative overflow-hidden">
          <img src={warehouseImage} alt={warehouseInfo?.name || 'Warehouse'} className="w-full h-full object-cover" />
        </div>

        <div className="relative">
          <UnifiedWarehouseMap warehouseInfo={warehouseInfo} mapId="warehouseImageAndMap" zoom={15} withMarkerPopups={false} />
        </div>
      </div>
    </div>
  );
});
